<template>
  <div class="ml-1">
    <TabelaCompraDepartamentos
      :cabecalhos_personalizado="cabecalhos"
      :height="height_tabela"
      ocultar_titulo
      ocultar_tela_cheia
      exibir_colunas_opcionais
      :grupo="grupo_compra"
      :filial="filial_compra"
      :departamento="departamento_compra"
      :linhas_removidas="linhas_removidas"
      :callback-nivel1="buscarDepartamento"
      :callback-nivel2="buscarCategoriasDepartamento"
      :callback-nivel3="buscarProdutosCategoria"
      :qtd_niveis_expancao="3"
      :item-class="classesCssLinha"
      @itens-data-table="atualizarTotais"
    >
      <template #topo-lado-direito>
        <span class="font-weight-medium font-15 mr-2" v-text="`Quantidade de itens: ${pedido.qtd_categorias}`" />
      </template>

      <template #item.preco_custo="{item}">
        <div v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO" class="text-center mr-2">-</div>

        <PrecoDeCusto
          v-else-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO"
          :linha="item"
          @click.stop
        />

        <div v-else class="text-center mr-2" v-text="Helpers.formatarValorMonetario(item.preco_custo)" />
      </template>

      <template #item.sugestao_compra_em_preco_de_custo="{item, custo_total_departamento_analise}">
        <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO">
          {{Helpers.formatarValorMonetario(custo_total_departamento_analise)}}
        </template>

        <template v-else>
          {{Helpers.formatarValorMonetario(item.preco_custo * item.sugestao_compra_em_quantidade)}}
        </template>
      </template>

      <template #item.sugestao_compra_em_quantidade_fixo="{item, item_nivel_acima}">
        <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO">
          {{ Helpers.formatarValor(totais.sugestao_compra_em_quantidade_fixo) }}
        </template>
        <template v-else-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO">
          {{ Helpers.formatarValor(item.sugestao_compra_em_quantidade_fixo) }}
        </template>
        <template v-else>
          {{ Helpers.formatarValor(item_nivel_acima.sugestao_compra_em_quantidade_fixo) }}
        </template>
        {{ item.unidade_compra }}
      </template>

      <template #item.sugestao_compra_em_quantidade="{item, qtd_sugestao_departamento_analise, item_nivel_acima}">
        <div class="d-flex" @click.stop>
          <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO">
            <SugestaoDeCompra :linha="item" class="mr-2" />
            <ExcluirProduto :linha="item" @produto-excluido-carrinho="produtoExcluidoCarrinho" />
          </template>

          <div v-else id="txt-sugestao-consolidada">
            <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.TERCEIRO">
              {{Helpers.formatarValor(item_nivel_acima.sugestao_compra_em_quantidade || 0)}}
            </template>
            <template v-else>{{Helpers.formatarValor(qtd_sugestao_departamento_analise)}}</template>
            {{item.unidade_compra}}
          </div>
        </div>
      </template>

      <template #footer.bloco.esquerdo>
        <div class="mt-6 ml-1 font-12 d-flex align-center text-truncate">
          <span class="quadrado-15 bg-red" />
          <span class="ma-0 ml-1">Quantidade diferente da sugestão</span>
        </div>
      </template>
    </TabelaCompraDepartamentos>
  </div>
</template>

<script>
import cabecalhos from "./Cabecalhos.js";
import TabelaCompraDepartamentos from "../../../utils/dataTable/sysDataTableDepartamentos/Index.vue";
import Responsividade from "../../../../helpers/ResponsiveHeight.js";
import {parametros_rota} from "../helpers/ParametrosRota";
import {NIVEIS_DE_EXPANCAO} from "../../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao";

import {buscarDepartamentoPedido} from "../../../../api/compraPorDepartamentos/PedidoCompraTipo.js";
import {buscarCategoriasDepartamentoPedido} from "../../../../api/compraPorDepartamentos/PedidoCompraTipo.js";
import {buscarProdutosCategoriaPedido} from "../../../../api/compraPorDepartamentos/PedidoCompraTipo.js";

import SugestaoDeCompra from "./acoesTabela/SugestaoDeCompra.vue";
import ExcluirProduto from "./acoesTabela/ExcluirProduto";
import PrecoDeCusto from "./acoesTabela/PrecoDeCusto";

export default {
  name: "TabelaProdutos",
  mixins: [Responsividade, parametros_rota],
  components: {
    PrecoDeCusto,
    TabelaCompraDepartamentos,
    SugestaoDeCompra,
    ExcluirProduto,
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    linhas_removidas: [],
    NIVEIS_DE_EXPANCAO,
    cabecalhos,
    totais: {
      sugestao_compra_em_quantidade_fixo: 0
    }
  }),
  computed: {
    height_tabela() {
      return parseInt(this.alturaDaJanela - 155);
    }
  },
  methods: {
    async buscarDepartamento() {
      if (this.pedido.id > 0) {
        return await buscarDepartamentoPedido(this.pedido.id);
      }
    },
    async buscarCategoriasDepartamento({iddepartamento}) {
      const categorias = await buscarCategoriasDepartamentoPedido(this.pedido.id);

      return categorias.map(item => {
        return {...item, iddepartamento, idsecao: 0, id_pedido: this.pedido.id};
      });
    },
    async buscarProdutosCategoria({iddepartamento, idcategoria}) {
      const produtos = await buscarProdutosCategoriaPedido(this.pedido.id, idcategoria);

      return produtos.map(item => {
        return {...item, iddepartamento, idsecao: 0, idcategoria, id_pedido: this.pedido.id};
      });
    },
    produtoExcluidoCarrinho(produto) {
      this.linhas_removidas.push(produto);
    },
    classesCssLinha(linha, linha_nivel_acima) {
      if (linha.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO) return {};

      const ativar_texto_vermelho = (linha.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO)
        ? Number(linha.sugestao_compra_em_quantidade) !== Number(linha.sugestao_compra_em_quantidade_fixo)
        : Number(linha_nivel_acima.sugestao_compra_em_quantidade) !== Number(linha_nivel_acima.sugestao_compra_em_quantidade_fixo);

      return {
        'text-red': ativar_texto_vermelho
      }
    },
    atualizarTotais(items_grid) {
      this.totais.sugestao_compra_em_quantidade_fixo = items_grid.reduce((a, b) => {
        if (b.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return a;

        return a + Number(b.sugestao_compra_em_quantidade_fixo);
      }, 0)
    }
  }
}
</script>

<style scoped>
#txt-sugestao-consolidada {
  text-align: center;
  width: 128px;
}
</style>
